import { FloatingFormItem } from '@/components/_common';

import { useFunctionUpdate } from '@/core/domain/enterprise/Functions/Functions.hooks';
import {
  EmployeeFunction,
  EmployeeFunctionUpdate,
} from '@/core/domain/enterprise/Functions/Functions.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';

type Props = ModalProps & {
  onCancel: () => void;
  employeeFunction?: EmployeeFunction;
};

export default function FunctionsUpdateModal(props: Props) {
  const requiredField = useDefaultEmptyFieldError();
  const [form] = Form.useForm<EmployeeFunctionUpdate>();

  const update = useFunctionUpdate();

  const handleCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  const handleEdit = async () => {
    const values = await form.validateFields();

    if (props?.employeeFunction) {
      await update.mutateAsync({ ...values, id: props.employeeFunction.id });

      handleCancel();
    }
  };

  useEffect(() => {
    if (props.employeeFunction) {
      form.setFieldsValue(props.employeeFunction);
    }
  }, [props.open, props.employeeFunction]);

  return (
    <Modal
      {...props}
      title="Editar Cargo"
      destroyOnClose
      onCancel={handleCancel}
      onOk={handleEdit}
      okText="Salvar"
    >
      <Form form={form}>
        <Row gutter={[12, 12]}>
          <Col span={24} md={12}>
            <FloatingFormItem name="name" label="Nome" rules={[requiredField]}>
              <Input maxLength={50} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              name="code"
              label="Código (CBO)"
              rules={[requiredField]}
            >
              <Input maxLength={10} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
